export default __webpack_public_path__ + "static/media/empty-cart.a77e8cf4.png";